<template>
  <div class="preview-prompt-card" @click="selectPrompt">
    <div v-if="prompt.cardGroupName" class="category-container">
      <span class="category">{{ prompt.cardGroupName }}</span>
    </div>
    <div v-if="prompt.title" class="title-container">
      <h3 class="title">{{ prompt.title }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromptCard',
  props: {
    prompt: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selectPrompt = () => {
      emit('select-prompt', props.prompt);
    };
    return {
      selectPrompt,
    };
  },
};
</script>

<style scoped lang="scss">
.preview-prompt-card {
  background: $bb-neutral-0;
  border-radius: $bb-spacing-2;
  padding: $bb-spacing-4;
  position: relative;
  min-height: 120px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid $bb-neutral-4;
  cursor: pointer;

  .category-container {
    position: absolute;
    top: $bb-spacing-3;
    left: $bb-spacing-3;

    .category {
      @include bb-medium-text-styles('xs');
      background-color: $bb-neutral-5;
      color: $bb-neutral-1;
      padding: $bb-spacing-1 $bb-spacing-2;
      border-radius: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  .title-container {
    display: flex;
    align-items: center;
    justify-content: center;

    .title {
      @include bb-medium-text-styles('lg');
      text-align: center;
    }
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .preview-prompt-card {
    padding: $bb-spacing-3;
    min-height: 100px;

    .title-container {
      .title {
        @include bb-medium-text-styles('md');
      }
    }
  }
}
</style>
